import React from "react";
import { Link } from "react-router-dom";
import { NavLink } from "reactstrap";

const LinkItem = props => {
  return (
    <NavLink tag={Link} to={props.route} active={props.pathname.indexOf(props.route) !== -1}>
      {props.name}
    </NavLink>
  );
};

export default LinkItem;


// WEBPACK FOOTER //
// ./src/common/LinkItem/LinkItem.js